export const createFetcher = (fetchFn, dataState, loadingState) => {
  let fetchId = 0
  return async (...args) => {
    const thisId = ++fetchId
    loadingState(true)
    try {
      const res = await fetchFn(...args)
      if (thisId !== fetchId) return res // stale response, skip
      if (res.ok) dataState(await res.json())
      return res
    } catch (err) {
      console.error(err)
    } finally {
      if (thisId === fetchId) loadingState(false)
    }
  }
}
